import { makeStyles } from '@material-ui/core/styles';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import { COLORS } from './../../../styles/constants';

export const useStyles = makeStyles(theme => ({
	chip: {
		width: props =>
			props.fullWidth &&
			`calc(100% / ${props.numberOfChips} - ${theme.spacing(1) * props.numberOfChips - theme.spacing(1)}px)`,
		minWidth: 55,
		height: '2.3em',
		backgroundColor: props => props.variant !== 'outlined' && COLORS.BACKGROUND_INPUT,
		border: props => props.variant === 'outlined' && `1px solid ${COLORS.BORDER_BUTTON_DEFAULT}`,
		fontSize: '11px',
		'& .MuiChip-avatar': {
			width: 20,
			height: 20
		},
		'&:hover, &:focus': {
			backgroundColor: COLORS.BACKGROUND_INPUT_HOVER
		}
	},
	selectedChip: {
		backgroundColor: props => (props.color === 'primary' ? theme.palette.primary.main : theme.palette.secondary.main),
		border: `1px solid ${theme.palette.secondary.main} !important`,
		color: theme.palette.common.white,
		'&:hover, &:focus': {
			backgroundColor: props =>
				props.color === 'primary'
					? `${lighten(theme.palette.primary.main, 0.2)} !important`
					: `${lighten(theme.palette.secondary.main, 0.2)} !important`
		}
	},
	selectedChipMultiple: {
		'& .MuiChip-label': {
			paddingLeft: 10
		}
	},
	formLabel: {
		marginBottom: theme.spacing(0.5)
	},
	formGroup: {
		display: 'flex',
		// justifyContent: 'center',
		flexDirection: 'row',
		flexWrap: 'wrap',
		marginLeft: -theme.spacing(0.3),
		'& > *': {
			margin: theme.spacing(0.3)
		}
	}
}));
